import { mapGetters, mapActions, mapState } from 'vuex'

// utils
import utils from '@/util'

// api
import FolderApi from '@/api/folder'
import presentationApi from '@/api/presentation'

export default {
  data() {
    return {
      folders: [],
      destinatedFolderId: null,
      loadingFolderTree: false,
    }
  },
  computed: {
    ...mapState({
      currentUser: (state) => state.currentUser,
    }),
    ...mapGetters('featureToggles', ['canUseMovePresentations']),
    ...mapGetters(['presentations']),
  },
  beforeDestroy() {
  },
  methods: {
    ...mapActions([
      'setPresentationsAction',
    ]),
    async getAndSetFolders() {
      this.loadingFolderTree = true
      const folderTree = await FolderApi.getFullFolderTree()
      const flatFolderTree = this._flattenFolderTree(folderTree)
      const isOwner = this.presentation ? this.currentUser.id === this.presentation.userId : true

      flatFolderTree.unshift({ folderId: null, folderName: this.$i18nPresenter.t('myPresentations') })
      this.folders = flatFolderTree.map((f) => {
        const isNotOwnerAndRootFolder = !isOwner && f.folderId === null
        return {
          ...f,
          disabled: this.selectedPresentations.some((p) => (p.folderId === f.folderId)
            || (f.countPresentation === this.parseIntMaxPresentationInFolder && f.depth && f.depth > 0))
            || isNotOwnerAndRootFolder,
          folderName: this.selectedPresentations.some((p) => p.folderId === f.folderId) ? `${f.folderName} (current)` : f.folderName,
        }
      })
      const enabled = this.folders.filter((f) => !f.disabled)
      this.destinatedFolderId = enabled && enabled[0] && enabled[0].folderId
      this.loadingFolderTree = false
    },
    _flattenFolderTree(folderTree) {
      return folderTree.reduce((acc, {
        folderId, folderName, parentFolderId, depth, folders, countPresentation, folderShareId, folderInviteId,
      }) => {
        acc.push({
          folderId, folderName, parentFolderId, depth, countPresentation, folderShareId, folderInviteId,
        })
        if (folders && folders.length > 0) {
          acc = acc.concat(this._flattenFolderTree(folders))
        }
        return acc
      }, [])
    },
    async handleMovePresn(data) {
      try {
        await presentationApi.movePresentations(data)

        const newPresentations = this.presentations.filter((p) => !data.presentationIds.includes(p.id))
        this.setPresentationsAction(newPresentations)

        let folderName = 'My presentations'
        if (this.destinatedFolderId) {
          folderName = this.folders
            .find((folder) => folder.folderId === this.destinatedFolderId).folderName
        }
        utils.showToastSuccess(`"${utils.sanitize(this.selectedPresentations[0].name)}" ${this.$i18nPresenter.t('moved to')} "${utils.sanitize(folderName)}"`)

        this.isShowingMovePresnModal = false
      } catch (error) {
        utils.showToastError(this.$i18nPresenter.t('Move presentations failed'))
      }
    },
    updateDestinatedFolderId(value) {
      this.destinatedFolderId = value
    },
    updateFolders(folders) {
      this.folders = folders
    },
  },
}
